import { omit } from '../../utils/props';
import { hasPublicCurrencyCode, hasPublicPurchaseRequest } from '../../utils/purchaseMotionTypeGuards';
import { ErrorBoundary, ErrorBoundaryNames } from '../ErrorBoundary';
import { OptionalDFCProvider } from '../PurchaseMotionCTA/OptionalDFCProvider';
import { DirectToBuyButton } from '../PurchaseMotions/DirectToBuyButton/DirectToBuyButton';
import { DirectToTrialButton } from '../PurchaseMotions/DirectToTrialButton/DirectToTrialButton';
import { PublicTalkToSalesButton } from '../PurchaseMotions/PublicTalkToSalesButton/PublicTalkToSalesButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicPurchaseMotionCTABase = ({
  apiName,
  ctaProps,
  purchaseMotion,
  uiButtonProps = {},
  trackingData,
  onClick,
  upgradeConfig,
  children,
  productSku,
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId
}) => {
  const filteredUiButtonProps = omit(uiButtonProps, ['children', 'className', 'external', 'href', 'onClick', 'style']);
  switch (purchaseMotion) {
    case 'BUY_TOUCHLESS':
      if (hasPublicPurchaseRequest(ctaProps) || hasPublicCurrencyCode(ctaProps)) {
        return /*#__PURE__*/_jsx(DirectToBuyButton, Object.assign({
          apiName: apiName,
          trackingData: trackingData,
          upgradeConfig: upgradeConfig,
          productSku: productSku,
          "data-test-id": dataTestId,
          "data-selenium-id": dataSeleniumId,
          uiButtonProps: filteredUiButtonProps,
          onClick: onClick
        }, ctaProps, {
          children: children
        }));
      } else {
        throw new Error('DirectToBuyButton requires either purchaseRequest or currencyCode');
      }
    case 'TALK_TO_SALES':
    case 'TALK_TO_SALES_FALLBACK':
      return /*#__PURE__*/_jsx(PublicTalkToSalesButton, Object.assign({
        apiName: apiName,
        trackingData: trackingData,
        upgradeConfig: upgradeConfig,
        productSku: productSku,
        "data-test-id": dataTestId,
        "data-selenium-id": dataSeleniumId,
        uiButtonProps: filteredUiButtonProps,
        onClick: onClick
      }, ctaProps, {
        children: children
      }));
    case 'TRIAL':
      return /*#__PURE__*/_jsx(DirectToTrialButton, Object.assign({
        apiName: apiName,
        trackingData: trackingData,
        upgradeConfig: upgradeConfig,
        productSku: productSku,
        "data-test-id": dataTestId,
        "data-selenium-id": dataSeleniumId,
        uiButtonProps: filteredUiButtonProps,
        onClick: onClick
      }, ctaProps, {
        children: children
      }));
    default:
      return null;
  }
};
export const PublicPurchaseMotionCTA = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.PURCHASE_MOTION_CTA,
  children: /*#__PURE__*/_jsx(OptionalDFCProvider, {
    children: /*#__PURE__*/_jsx(PublicPurchaseMotionCTABase, Object.assign({}, props))
  })
});